import { mapCollection, sortByNumber } from '../../utils/collection.utils';
import { WorkingShiftDateRange } from '../calendar/working-shift-date-range';
import { WorkingShiftDateRangeHourRangeBuilder } from './working-shift-date-range-hour-range.builder';

export class WorkingShiftDateRangeBuilder {
  static fromJson(json) {
    return (json)
      ? new WorkingShiftDateRange(
        json.hash,
        json.startDate,
        json.endDate,
        json.hourRanges ? WorkingShiftDateRangeHourRangeBuilder.fromList(sortByNumber('startTime', json.hourRanges)) : []
      )
      : null;
  }

  static fromList(list) {
    return sortByNumber('startDate', mapCollection(WorkingShiftDateRangeBuilder.fromJson, list));
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/working-shift-date-range.builder.ts